import { useSummary } from '@/hooks/useCompany';
import { usePortfolioAction } from './usePortfolioAction';
import { useWatchAction } from './useWatchAction';
import { useNoteAction } from './useNoteAction';
import { useCompareAction } from './useCompareAction';
import { useShareAction } from './useShareAction';
import { usePdfAction } from './usePdfAction';
import { useCsvAction } from './useCsvAction';

/**
 * This hook returns an array of actions (buttons/dropdown items) that are
 * available for the company report actions row.
 */
export const useActions = () => {
  const summary = useSummary();
  const {
    companyId = '',
    uniqueSymbol = '',
    canonicalUrl = '',
    tickerSymbol = '',
  } = summary.status === 'success' ? summary : {};

  const portfolioAction = usePortfolioAction({ companyId, tickerSymbol });
  const watchAction = useWatchAction();
  const noteAction = useNoteAction();
  const compareAction = useCompareAction({ uniqueSymbol });
  const shareAction = useShareAction();
  const pdfAction = usePdfAction();
  const csvAction = useCsvAction({ canonicalUrl, uniqueSymbol });

  return [
    portfolioAction,
    watchAction,
    noteAction,
    compareAction,
    shareAction,
    pdfAction,
    csvAction,
  ].filter((action) => !action.isHidden);
};
